(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[3104],{

/***/ 43104:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ MerchModule_MerchModule; }
});

// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/extends.js
var esm_extends = __webpack_require__(87462);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/prop-types/index.js
var prop_types = __webpack_require__(45697);
var prop_types_default = /*#__PURE__*/__webpack_require__.n(prop_types);
// EXTERNAL MODULE: ./node_modules/styled-components/dist/styled-components.browser.esm.js + 4 modules
var styled_components_browser_esm = __webpack_require__(87379);
// EXTERNAL MODULE: ./node_modules/styled-system/dist/index.esm.js
var index_esm = __webpack_require__(99278);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Flex/Flex.js
var Flex = __webpack_require__(92833);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Text/Text.js + 2 modules
var Text = __webpack_require__(23720);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Heading/Heading.js
var Heading = __webpack_require__(97331);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Layout/Layout.js
var Layout = __webpack_require__(88939);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Container/Container.js
var Container = __webpack_require__(32223);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Box/Box.js
var Box = __webpack_require__(92591);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Image/Image.js
var Image = __webpack_require__(38489);
// EXTERNAL MODULE: ./node_modules/pcln-design-system/lib-esm/Link/Link.js
var Link = __webpack_require__(40869);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectSpread2.js
var objectSpread2 = __webpack_require__(1413);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js
var objectWithoutProperties = __webpack_require__(45987);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/classCallCheck.js
var classCallCheck = __webpack_require__(15671);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/createClass.js
var createClass = __webpack_require__(43144);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/assertThisInitialized.js
var assertThisInitialized = __webpack_require__(97326);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/inherits.js
var inherits = __webpack_require__(60136);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js
var possibleConstructorReturn = __webpack_require__(82963);
// EXTERNAL MODULE: ./node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js
var getPrototypeOf = __webpack_require__(61120);
;// CONCATENATED MODULE: ./node_modules/@pcln/react-analytics/dist/esm/AnalyticsOnClick.js
var _excluded=["children","fireOnce","action","category","label","onClick"];function _createSuper(Derived){var hasNativeReflectConstruct=_isNativeReflectConstruct();return function _createSuperInternal(){var Super=(0,getPrototypeOf/* default */.Z)(Derived),result;if(hasNativeReflectConstruct){var NewTarget=(0,getPrototypeOf/* default */.Z)(this).constructor;result=Reflect.construct(Super,arguments,NewTarget);}else{result=Super.apply(this,arguments);}return (0,possibleConstructorReturn/* default */.Z)(this,result);};}function _isNativeReflectConstruct(){if(typeof Reflect==="undefined"||!Reflect.construct)return false;if(Reflect.construct.sham)return false;if(typeof Proxy==="function")return true;try{Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],function(){}));return true;}catch(e){return false;}}/* eslint-disable no-unused-vars */var propTypes={children:(prop_types_default()).element,/** For overriding default category */category:(prop_types_default()).string,action:(prop_types_default()).string.isRequired,label:(prop_types_default()).string.isRequired,/** Tag will only fire one time if this is true. */fireOnce:(prop_types_default()).bool,onClick:(prop_types_default()).func};var contextTypes={analytics:prop_types_default().shape({logEvent:(prop_types_default()).func,gaCategory:(prop_types_default()).string})};var AnalyticsOnClick=/*#__PURE__*/function(_React$Component){(0,inherits/* default */.Z)(AnalyticsOnClick,_React$Component);var _super=_createSuper(AnalyticsOnClick);function AnalyticsOnClick(props){var _this;(0,classCallCheck/* default */.Z)(this,AnalyticsOnClick);_this=_super.call(this,props);_this.state={tagFired:false};_this.enhancedClick=_this.enhancedClick.bind((0,assertThisInitialized/* default */.Z)(_this));return _this;}(0,createClass/* default */.Z)(AnalyticsOnClick,[{key:"enhancedClick",value:function enhancedClick(event){this.context.analytics.logEvent({category:this.props.category||this.context.analytics.gaCategory,action:this.props.action,label:this.props.label});if(this.props.children.props.onClick){this.props.children.props.onClick(event);}this.setState({tagFired:true});}},{key:"render",value:function render(){var _this$props=this.props,children=_this$props.children,fireOnce=_this$props.fireOnce,action=_this$props.action,category=_this$props.category,label=_this$props.label,onClick=_this$props.onClick,props=(0,objectWithoutProperties/* default */.Z)(_this$props,_excluded);var childElement=this.props.children;if(!this.context.analytics||this.state.tagFired&&fireOnce){return this.props.children;}else{return/*#__PURE__*/react.cloneElement(childElement,(0,objectSpread2/* default */.Z)({onClick:this.enhancedClick},props));}}}]);return AnalyticsOnClick;}(react.Component);AnalyticsOnClick.propTypes=propTypes;AnalyticsOnClick.contextTypes=contextTypes;/* harmony default export */ var esm_AnalyticsOnClick = (AnalyticsOnClick);
//# sourceMappingURL=AnalyticsOnClick.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/marketing/dist/esm/MerchImage/MerchImage.js
var ResponsiveImage=(0,styled_components_browser_esm/* default */.ZP)(Image/* default */.Z).withConfig({displayName:"MerchImage__ResponsiveImage",componentId:"sc-16ti2t2-0"})(["aspect-ratio:",";object-fit:",";display:flex;max-height:250px;min-height:unset;","{min-height:",";max-height:500px;}"],function(props){return props.imageAspectRatio?props.imageAspectRatio:'16/9';},function(props){return props.objectFit?props.objectFit:'contain';},(0,index_esm/* themeGet */.R)('mediaQueries.md'),function(props){return props.minImageHeight?props.minImageHeight:'250px';});var CreateLink=function CreateLink(_ref){var minImageHeight=_ref.minImageHeight,imageUrl=_ref.imageUrl,imageAlt=_ref.imageAlt,callToAction=_ref.callToAction,borderRadius=_ref.borderRadius,imageAspectRatio=_ref.imageAspectRatio,objectFit=_ref.objectFit;return/*#__PURE__*/react.createElement(Link/* default */.Z,{href:callToAction.url,target:callToAction.openInNewTab?'_blank':undefined,rel:callToAction.openInNewTab?'noopener':undefined,"data-testid":"image-link-id"},/*#__PURE__*/react.createElement(ResponsiveImage,{minImageHeight:minImageHeight,objectFit:objectFit,imageAspectRatio:imageAspectRatio,src:imageUrl,alt:imageAlt,borderRadius:borderRadius}));};function MerchImage(_ref2){var minImageHeight=_ref2.minImageHeight,imageUrl=_ref2.imageUrl,imageAlt=_ref2.imageAlt,callToAction=_ref2.callToAction,borderRadius=_ref2.borderRadius,imageAspectRatio=_ref2.imageAspectRatio,objectFit=_ref2.objectFit;var _ref3=(callToAction===null||callToAction===void 0?void 0:callToAction.googleAnalyticsTracking)||{},action=_ref3.action,category=_ref3.category,label=_ref3.label;if(callToAction!==null&&callToAction!==void 0&&callToAction.url&&category&&action&&label){return/*#__PURE__*/react.createElement(esm_AnalyticsOnClick,{action:callToAction.googleAnalyticsTracking.action,label:callToAction.googleAnalyticsTracking.label,category:callToAction.googleAnalyticsTracking.category},/*#__PURE__*/react.createElement(CreateLink,{minImageHeight:minImageHeight,objectFit:objectFit,imageAspectRatio:imageAspectRatio,imageUrl:imageUrl,imageAlt:imageAlt,callToAction:callToAction,borderRadius:borderRadius}));}else if(callToAction!==null&&callToAction!==void 0&&callToAction.url){return/*#__PURE__*/react.createElement(CreateLink,{minImageHeight:minImageHeight,objectFit:objectFit,imageAspectRatio:imageAspectRatio,imageUrl:imageUrl,imageAlt:imageAlt,callToAction:callToAction,borderRadius:borderRadius});}else{return/*#__PURE__*/react.createElement(ResponsiveImage,{minImageHeight:minImageHeight,objectFit:objectFit,imageAspectRatio:imageAspectRatio,src:imageUrl,alt:imageAlt,borderRadius:borderRadius});}}MerchImage.propTypes={minImageHeight:(prop_types_default()).string,imageAlt:(prop_types_default()).string,imageUrl:(prop_types_default()).string,objectFit:prop_types_default().oneOf(['contain','cover']),callToAction:(prop_types_default()).object,borderRadius:(prop_types_default()).string,imageAspectRatio:prop_types_default().oneOf(['1/1','3/2','4/3','16/9'])};CreateLink.propTypes={objectFit:prop_types_default().oneOf(['contain','cover']),imageAlt:(prop_types_default()).string,imageUrl:(prop_types_default()).string,callToAction:(prop_types_default()).object,borderRadius:(prop_types_default()).string,imageAspectRatio:prop_types_default().oneOf(['1/1','3/2','4/3','16/9']),minImageHeight:(prop_types_default()).string};/* harmony default export */ var MerchImage_MerchImage = (MerchImage);
//# sourceMappingURL=MerchImage.js.map
;// CONCATENATED MODULE: ./node_modules/@pcln/marketing/dist/esm/MerchModule/MerchModule.js
var defaultListStyling=(0,styled_components_browser_esm/* css */.iv)(["display:block;padding-left:","px;& li > p{margin:","px 0;}"],(0,index_esm/* themeGet */.R)('space.4'),(0,index_esm/* themeGet */.R)('space.3'));var ModuleWrapper=(0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({displayName:"MerchModule__ModuleWrapper",componentId:"sc-14j1nf9-0"})(["display:flex;max-width:1280px;margin:0 auto;& ul,& ol{display:flex;flex-direction:column;list-style-type:none;padding-left:0;& li > p{margin:","px 0;}","{","}}& ul{","{list-style-type:",";}}& ol{","{list-style-type:",";}}"],(0,index_esm/* themeGet */.R)('space.0'),(0,index_esm/* themeGet */.R)('mediaQueries.lg'),function(props){return props.textAlign!=='center'&&defaultListStyling;},(0,index_esm/* themeGet */.R)('mediaQueries.lg'),function(props){return props.textAlign==='center'?'none':'disc';},(0,index_esm/* themeGet */.R)('mediaQueries.lg'),function(props){return props.textAlign==='center'?'none':'decimal';});var ImageWrapper=(0,styled_components_browser_esm/* default */.ZP)(Flex/* default */.Z).withConfig({displayName:"MerchModule__ImageWrapper",componentId:"sc-14j1nf9-1"})(["display:",";","{display:flex;}","{display:flex;}"],function(props){return props.imageDisplayMobile?'flex':'none';},(0,index_esm/* themeGet */.R)('mediaQueries.lg'),(0,index_esm/* themeGet */.R)('mediaQueries.md'));function MerchModule(_ref){var tagline=_ref.tagline,taglineColor=_ref.taglineColor,headline=_ref.headline,headlineColor=_ref.headlineColor,body=_ref.body,imageAlt=_ref.imageAlt,imageUrl=_ref.imageUrl,imageDisplayMobile=_ref.imageDisplayMobile,callToAction=_ref.callToAction,mediaDisplay=_ref.mediaDisplay,actions=_ref.actions,textAlign=_ref.textAlign,mediaPosition=_ref.mediaPosition,headingFontSize=_ref.headingFontSize,headingMB=_ref.headingMB,taglineTextStyle=_ref.taglineTextStyle,bodyLineHeight=_ref.bodyLineHeight,headingTextStyle=_ref.headingTextStyle,backgroundColor=_ref.backgroundColor,columnVariation=_ref.columnVariation,boxProps=_ref.boxProps,imageAspectRatio=_ref.imageAspectRatio,minImageHeight=_ref.minImageHeight,isBox=_ref.isBox,isMobile=_ref.isMobile;var bgCheck=backgroundColor.split('.');var isDark=bgCheck[1]==='dark'||bgCheck[1]==='darkest'||bgCheck[1]==='shade';if(isDark){headlineColor='text.lightest';taglineColor='text.lightest';}var wrapperDirection=mediaPosition==='right'?'row-reverse':mediaPosition==='center'?'column-reverse':'row';var wrapperDirectionResponsive=[imageDisplayMobile?'column-reverse':wrapperDirection,null,null,wrapperDirection];var textWrapperAlign=mediaPosition==='center'?'center':['center',null,null,'left'];var MerchBody=function MerchBody(){return/*#__PURE__*/react.createElement(Flex/* default */.Z,{height:"100%",flexDirection:"column",justifyContent:"center",textAlign:textWrapperAlign,"data-testid":"merch-module-text-wrapper"},tagline&&/*#__PURE__*/react.createElement(Text/* default */.ZP,{textAlign:textAlign,fontSize:0,fontWeight:"bold",textTransform:"caps",color:taglineColor,mb:headline&&3,textStyle:taglineTextStyle,"data-testid":"tagline-text"},tagline),/*#__PURE__*/react.createElement(Heading/* default.h3 */.Z.h3,{textAlign:textAlign,fontSize:headingFontSize,textStyle:headingTextStyle,fontWeight:"bold",color:headlineColor,mt:0,mb:headingMB,"data-testid":"header-wrapper"},headline),body&&/*#__PURE__*/react.cloneElement(body,{fontSize:body.props.fontSize||[2,null,null,null,3],lineHeight:bodyLineHeight,textStyle:body.props.textStyle||'',textAlign:textAlign,color:isDark?'text.lightest':body.props.color}),actions&&/*#__PURE__*/react.createElement(Flex/* default */.Z,{justifyContent:textAlign},actions));};var MerchImageLogic=function MerchImageLogic(){if(imageUrl){return/*#__PURE__*/react.createElement(ImageWrapper,{justifyContent:"center",height:"100%",imageDisplayMobile:imageDisplayMobile,"data-testid":"image-wrapper"},/*#__PURE__*/react.createElement(MerchImage_MerchImage,{minImageHeight:minImageHeight,objectFit:mediaDisplay,imageAspectRatio:imageAspectRatio,imageUrl:imageUrl,imageAlt:imageAlt,callToAction:callToAction,borderRadius:"lg"}));}return null;};var MerchModuleLogic=function MerchModuleLogic(){return/*#__PURE__*/react.createElement(ModuleWrapper,{alignItems:"center",flexDirection:wrapperDirectionResponsive,justifyContent:"space-between",textAlign:textAlign,imageDisplayMobile:imageDisplayMobile,"data-testid":"merch-module-wrapper"},mediaPosition==='right'&&!isMobile?/*#__PURE__*/react.createElement(Layout/* default */.Z,{flexWrap:['wrap-reverse','wrap-reverse',null,null,'wrap'],variation:columnVariation,rowGap:"lg",gap:['lg',null,null,'xl']},/*#__PURE__*/react.createElement(MerchBody,null),/*#__PURE__*/react.createElement(MerchImageLogic,null)):mediaPosition==='center'&&!isMobile?/*#__PURE__*/react.createElement(Layout/* default */.Z,{variation:"100",rowGap:"lg",gap:['lg',null,null,'xl']},/*#__PURE__*/react.createElement(MerchImageLogic,null),/*#__PURE__*/react.createElement(MerchBody,null)):mediaPosition==='left'&&!isMobile?/*#__PURE__*/react.createElement(Layout/* default */.Z,{variation:columnVariation,rowGap:"lg",gap:['lg',null,null,'xl']},/*#__PURE__*/react.createElement(MerchImageLogic,null),/*#__PURE__*/react.createElement(MerchBody,null)):isMobile&&!imageDisplayMobile?/*#__PURE__*/react.createElement(Layout/* default */.Z,{variation:columnVariation,rowGap:"lg",gap:['lg',null,null,'xl']},/*#__PURE__*/react.createElement(MerchBody,null)):/*#__PURE__*/react.createElement(Layout/* default */.Z,{variation:columnVariation,rowGap:"lg",gap:['lg',null,null,'xl']},/*#__PURE__*/react.createElement(MerchImageLogic,null),/*#__PURE__*/react.createElement(MerchBody,null)));};return/*#__PURE__*/react.createElement(Container/* default */.Z,null,isBox?/*#__PURE__*/react.createElement(Box/* default */.Z,(0,esm_extends/* default */.Z)({color:backgroundColor},boxProps,{borderRadius:"xl",boxShadowSize:"sm","data-testid":"merch-module-box"}),/*#__PURE__*/react.createElement(MerchModuleLogic,null)):/*#__PURE__*/react.createElement(Container/* default */.Z,{color:backgroundColor,"data-testid":"merch-module-container"},/*#__PURE__*/react.createElement(MerchModuleLogic,null)));}MerchModule.propTypes={tagline:(prop_types_default()).string,taglineColor:(prop_types_default()).string,headline:(prop_types_default()).string.isRequired,headlineColor:(prop_types_default()).string,body:(prop_types_default()).node,imageAlt:(prop_types_default()).string,imageUrl:(prop_types_default()).string,imageDisplayMobile:(prop_types_default()).bool,callToAction:(prop_types_default()).node,actions:(prop_types_default()).node,textAlign:prop_types_default().oneOf(['left','center','right']),mediaDisplay:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).array]),headingFontSize:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).number,(prop_types_default()).array]),headingTextStyle:(prop_types_default()).string,taglineTextStyle:(prop_types_default()).string,bodyLineHeight:(prop_types_default()).string,headingMB:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).number]),backgroundColor:(prop_types_default()).string,columnVariation:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).array]),imageAspectRatio:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).array]),isBox:(prop_types_default()).bool,mediaPosition:prop_types_default().oneOfType([(prop_types_default()).string,(prop_types_default()).array]),boxProps:(prop_types_default()).object,minImageHeight:(prop_types_default()).string,isMobile:(prop_types_default()).bool};MerchModule.defaultProps={taglineColor:'text.light',headlineColor:'text.base',textAlign:'left',headingFontSize:[4,null,null,null,5],headingMB:3,headingTextStyle:'',taglineTextStyle:'',bodyLineHeight:'',columnVariation:['100',null,'50-50'],isBox:true,mediaDisplay:'contain',imageAspectRatio:'16/9',imageDisplayMobile:false,backgroundColor:'background.light',mediaPosition:'right',minImageHeight:'250px',isMobile:false,boxProps:{p:'4'}};/* harmony default export */ var MerchModule_MerchModule = (MerchModule);
//# sourceMappingURL=MerchModule.js.map

/***/ }),

/***/ 58367:
/***/ (function(__unused_webpack_module, exports) {

(function (global, factory) {
   true ? factory(exports) :
  0;
})(this, (function (exports) { 'use strict';

  var HAS_WEAK_MAP_SUPPORT = typeof WeakMap === 'function';
  var keys = Object.keys;
  /**
   * are the values passed strictly equal or both NaN
   *
   * @param a the value to compare against
   * @param b the value to test
   * @returns are the values equal by the SameValueZero principle
   */
  function sameValueZeroEqual(a, b) {
      return a === b || (a !== a && b !== b);
  }
  /**
   * is the value a plain object
   *
   * @param value the value to test
   * @returns is the value a plain object
   */
  function isPlainObject(value) {
      return value.constructor === Object || value.constructor == null;
  }
  /**
   * is the value promise-like (meaning it is thenable)
   *
   * @param value the value to test
   * @returns is the value promise-like
   */
  function isPromiseLike(value) {
      return !!value && typeof value.then === 'function';
  }
  /**
   * is the value passed a react element
   *
   * @param value the value to test
   * @returns is the value a react element
   */
  function isReactElement(value) {
      return !!(value && value.$$typeof);
  }
  /**
   * in cases where WeakMap is not supported, creates a new custom
   * object that mimics the necessary API aspects for cache purposes
   *
   * @returns the new cache object
   */
  function getNewCacheFallback() {
      var entries = [];
      return {
          delete: function (key) {
              for (var index = 0; index < entries.length; ++index) {
                  if (entries[index][0] === key) {
                      entries.splice(index, 1);
                      return;
                  }
              }
          },
          get: function (key) {
              for (var index = 0; index < entries.length; ++index) {
                  if (entries[index][0] === key) {
                      return entries[index][1];
                  }
              }
          },
          set: function (key, value) {
              for (var index = 0; index < entries.length; ++index) {
                  if (entries[index][0] === key) {
                      entries[index][1] = value;
                      return;
                  }
              }
              entries.push([key, value]);
          }
      };
  }
  /**
   * get a new cache object to prevent circular references
   *
   * @returns the new cache object
   */
  var getNewCache = (function (canUseWeakMap) {
      if (canUseWeakMap) {
          return function _getNewCache() {
              return new WeakMap();
          };
      }
      return getNewCacheFallback;
  })(HAS_WEAK_MAP_SUPPORT);
  /**
   * create a custom isEqual handler specific to circular objects
   *
   * @param [isEqual] the isEqual comparator to use instead of isDeepEqual
   * @returns the method to create the `isEqual` function
   */
  function createCircularEqualCreator(isEqual) {
      return function createCircularEqual(comparator) {
          var _comparator = isEqual || comparator;
          return function circularEqual(a, b, indexOrKeyA, indexOrKeyB, parentA, parentB, cache) {
              if (cache === void 0) { cache = getNewCache(); }
              var isCacheableA = !!a && typeof a === 'object';
              var isCacheableB = !!b && typeof b === 'object';
              if (isCacheableA !== isCacheableB) {
                  return false;
              }
              if (!isCacheableA && !isCacheableB) {
                  return _comparator(a, b, cache);
              }
              var cachedA = cache.get(a);
              if (cachedA && cache.get(b)) {
                  return cachedA === b;
              }
              cache.set(a, b);
              cache.set(b, a);
              var result = _comparator(a, b, cache);
              cache.delete(a);
              cache.delete(b);
              return result;
          };
      };
  }
  /**
   * are the arrays equal in value
   *
   * @param a the array to test
   * @param b the array to test against
   * @param isEqual the comparator to determine equality
   * @param meta the meta object to pass through
   * @returns are the arrays equal
   */
  function areArraysEqual(a, b, isEqual, meta) {
      var index = a.length;
      if (b.length !== index) {
          return false;
      }
      while (index-- > 0) {
          if (!isEqual(a[index], b[index], index, index, a, b, meta)) {
              return false;
          }
      }
      return true;
  }
  /**
   * are the maps equal in value
   *
   * @param a the map to test
   * @param b the map to test against
   * @param isEqual the comparator to determine equality
   * @param meta the meta map to pass through
   * @returns are the maps equal
   */
  function areMapsEqual(a, b, isEqual, meta) {
      var isValueEqual = a.size === b.size;
      if (isValueEqual && a.size) {
          var matchedIndices_1 = {};
          var indexA_1 = 0;
          a.forEach(function (aValue, aKey) {
              if (isValueEqual) {
                  var hasMatch_1 = false;
                  var matchIndexB_1 = 0;
                  b.forEach(function (bValue, bKey) {
                      if (!hasMatch_1 && !matchedIndices_1[matchIndexB_1]) {
                          hasMatch_1 =
                              isEqual(aKey, bKey, indexA_1, matchIndexB_1, a, b, meta) &&
                                  isEqual(aValue, bValue, aKey, bKey, a, b, meta);
                          if (hasMatch_1) {
                              matchedIndices_1[matchIndexB_1] = true;
                          }
                      }
                      matchIndexB_1++;
                  });
                  indexA_1++;
                  isValueEqual = hasMatch_1;
              }
          });
      }
      return isValueEqual;
  }
  var OWNER = '_owner';
  var hasOwnProperty = Function.prototype.bind.call(Function.prototype.call, Object.prototype.hasOwnProperty);
  /**
   * are the objects equal in value
   *
   * @param a the object to test
   * @param b the object to test against
   * @param isEqual the comparator to determine equality
   * @param meta the meta object to pass through
   * @returns are the objects equal
   */
  function areObjectsEqual(a, b, isEqual, meta) {
      var keysA = keys(a);
      var index = keysA.length;
      if (keys(b).length !== index) {
          return false;
      }
      if (index) {
          var key = void 0;
          while (index-- > 0) {
              key = keysA[index];
              if (key === OWNER) {
                  var reactElementA = isReactElement(a);
                  var reactElementB = isReactElement(b);
                  if ((reactElementA || reactElementB) &&
                      reactElementA !== reactElementB) {
                      return false;
                  }
              }
              if (!hasOwnProperty(b, key) ||
                  !isEqual(a[key], b[key], key, key, a, b, meta)) {
                  return false;
              }
          }
      }
      return true;
  }
  /**
   * are the regExps equal in value
   *
   * @param a the regExp to test
   * @param b the regExp to test agains
   * @returns are the regExps equal
   */
  var areRegExpsEqual = (function () {
      if (/foo/g.flags === 'g') {
          return function areRegExpsEqual(a, b) {
              return a.source === b.source && a.flags === b.flags;
          };
      }
      return function areRegExpsEqualFallback(a, b) {
          return (a.source === b.source &&
              a.global === b.global &&
              a.ignoreCase === b.ignoreCase &&
              a.multiline === b.multiline &&
              a.unicode === b.unicode &&
              a.sticky === b.sticky &&
              a.lastIndex === b.lastIndex);
      };
  })();
  /**
   * are the sets equal in value
   *
   * @param a the set to test
   * @param b the set to test against
   * @param isEqual the comparator to determine equality
   * @param meta the meta set to pass through
   * @returns are the sets equal
   */
  function areSetsEqual(a, b, isEqual, meta) {
      var isValueEqual = a.size === b.size;
      if (isValueEqual && a.size) {
          var matchedIndices_2 = {};
          a.forEach(function (aValue, aKey) {
              if (isValueEqual) {
                  var hasMatch_2 = false;
                  var matchIndex_1 = 0;
                  b.forEach(function (bValue, bKey) {
                      if (!hasMatch_2 && !matchedIndices_2[matchIndex_1]) {
                          hasMatch_2 = isEqual(aValue, bValue, aKey, bKey, a, b, meta);
                          if (hasMatch_2) {
                              matchedIndices_2[matchIndex_1] = true;
                          }
                      }
                      matchIndex_1++;
                  });
                  isValueEqual = hasMatch_2;
              }
          });
      }
      return isValueEqual;
  }

  var HAS_MAP_SUPPORT = typeof Map === 'function';
  var HAS_SET_SUPPORT = typeof Set === 'function';
  var valueOf = Object.prototype.valueOf;
  function createComparator(createIsEqual) {
      var isEqual = 
      /* eslint-disable no-use-before-define */
      typeof createIsEqual === 'function'
          ? createIsEqual(comparator)
          : function (a, b, indexOrKeyA, indexOrKeyB, parentA, parentB, meta) { return comparator(a, b, meta); };
      /* eslint-enable */
      /**
       * compare the value of the two objects and return true if they are equivalent in values
       *
       * @param a the value to test against
       * @param b the value to test
       * @param [meta] an optional meta object that is passed through to all equality test calls
       * @returns are a and b equivalent in value
       */
      function comparator(a, b, meta) {
          if (a === b) {
              return true;
          }
          if (a && b && typeof a === 'object' && typeof b === 'object') {
              if (isPlainObject(a) && isPlainObject(b)) {
                  return areObjectsEqual(a, b, isEqual, meta);
              }
              var aShape = Array.isArray(a);
              var bShape = Array.isArray(b);
              if (aShape || bShape) {
                  return aShape === bShape && areArraysEqual(a, b, isEqual, meta);
              }
              aShape = a instanceof Date;
              bShape = b instanceof Date;
              if (aShape || bShape) {
                  return (aShape === bShape && sameValueZeroEqual(a.getTime(), b.getTime()));
              }
              aShape = a instanceof RegExp;
              bShape = b instanceof RegExp;
              if (aShape || bShape) {
                  return aShape === bShape && areRegExpsEqual(a, b);
              }
              if (isPromiseLike(a) || isPromiseLike(b)) {
                  return a === b;
              }
              if (HAS_MAP_SUPPORT) {
                  aShape = a instanceof Map;
                  bShape = b instanceof Map;
                  if (aShape || bShape) {
                      return aShape === bShape && areMapsEqual(a, b, isEqual, meta);
                  }
              }
              if (HAS_SET_SUPPORT) {
                  aShape = a instanceof Set;
                  bShape = b instanceof Set;
                  if (aShape || bShape) {
                      return aShape === bShape && areSetsEqual(a, b, isEqual, meta);
                  }
              }
              if (a.valueOf !== valueOf || b.valueOf !== valueOf) {
                  return sameValueZeroEqual(a.valueOf(), b.valueOf());
              }
              return areObjectsEqual(a, b, isEqual, meta);
          }
          return a !== a && b !== b;
      }
      return comparator;
  }

  var deepEqual = createComparator();
  var shallowEqual = createComparator(function () { return sameValueZeroEqual; });
  var circularDeepEqual = createComparator(createCircularEqualCreator());
  var circularShallowEqual = createComparator(createCircularEqualCreator(sameValueZeroEqual));

  exports.circularDeepEqual = circularDeepEqual;
  exports.circularShallowEqual = circularShallowEqual;
  exports.createCustomEqual = createComparator;
  exports.deepEqual = deepEqual;
  exports.sameValueZeroEqual = sameValueZeroEqual;
  exports.shallowEqual = shallowEqual;

  Object.defineProperty(exports, '__esModule', { value: true });

}));
//# sourceMappingURL=fast-equals.js.map


/***/ }),

/***/ 42568:
/***/ (function(module) {

(function (global, factory) {
     true ? module.exports = factory() :
    0;
})(this, (function () { 'use strict';

    /**
     * @constant DEFAULT_OPTIONS_KEYS the default options keys
     */
    var DEFAULT_OPTIONS_KEYS = {
        isEqual: true,
        isMatchingKey: true,
        isPromise: true,
        maxSize: true,
        onCacheAdd: true,
        onCacheChange: true,
        onCacheHit: true,
        transformKey: true,
    };
    /**
     * @function slice
     *
     * @description
     * slice.call() pre-bound
     */
    var slice = Array.prototype.slice;
    /**
     * @function cloneArray
     *
     * @description
     * clone the array-like object and return the new array
     *
     * @param arrayLike the array-like object to clone
     * @returns the clone as an array
     */
    function cloneArray(arrayLike) {
        var length = arrayLike.length;
        if (!length) {
            return [];
        }
        if (length === 1) {
            return [arrayLike[0]];
        }
        if (length === 2) {
            return [arrayLike[0], arrayLike[1]];
        }
        if (length === 3) {
            return [arrayLike[0], arrayLike[1], arrayLike[2]];
        }
        return slice.call(arrayLike, 0);
    }
    /**
     * @function getCustomOptions
     *
     * @description
     * get the custom options on the object passed
     *
     * @param options the memoization options passed
     * @returns the custom options passed
     */
    function getCustomOptions(options) {
        var customOptions = {};
        /* eslint-disable no-restricted-syntax */
        for (var key in options) {
            if (!DEFAULT_OPTIONS_KEYS[key]) {
                customOptions[key] = options[key];
            }
        }
        /* eslint-enable */
        return customOptions;
    }
    /**
     * @function isMemoized
     *
     * @description
     * is the function passed already memoized
     *
     * @param fn the function to test
     * @returns is the function already memoized
     */
    function isMemoized(fn) {
        return (typeof fn === 'function' &&
            fn.isMemoized);
    }
    /**
     * @function isSameValueZero
     *
     * @description
     * are the objects equal based on SameValueZero equality
     *
     * @param object1 the first object to compare
     * @param object2 the second object to compare
     * @returns are the two objects equal
     */
    function isSameValueZero(object1, object2) {
        // eslint-disable-next-line no-self-compare
        return object1 === object2 || (object1 !== object1 && object2 !== object2);
    }
    /**
     * @function mergeOptions
     *
     * @description
     * merge the options into the target
     *
     * @param existingOptions the options provided
     * @param newOptions the options to include
     * @returns the merged options
     */
    function mergeOptions(existingOptions, newOptions) {
        // @ts-ignore
        var target = {};
        /* eslint-disable no-restricted-syntax */
        for (var key in existingOptions) {
            target[key] = existingOptions[key];
        }
        for (var key in newOptions) {
            target[key] = newOptions[key];
        }
        /* eslint-enable */
        return target;
    }

    // utils
    var Cache = /** @class */ (function () {
        function Cache(options) {
            this.keys = [];
            this.values = [];
            this.options = options;
            var isMatchingKeyFunction = typeof options.isMatchingKey === 'function';
            if (isMatchingKeyFunction) {
                this.getKeyIndex = this._getKeyIndexFromMatchingKey;
            }
            else if (options.maxSize > 1) {
                this.getKeyIndex = this._getKeyIndexForMany;
            }
            else {
                this.getKeyIndex = this._getKeyIndexForSingle;
            }
            this.canTransformKey = typeof options.transformKey === 'function';
            this.shouldCloneArguments = this.canTransformKey || isMatchingKeyFunction;
            this.shouldUpdateOnAdd = typeof options.onCacheAdd === 'function';
            this.shouldUpdateOnChange = typeof options.onCacheChange === 'function';
            this.shouldUpdateOnHit = typeof options.onCacheHit === 'function';
        }
        Object.defineProperty(Cache.prototype, "size", {
            get: function () {
                return this.keys.length;
            },
            enumerable: false,
            configurable: true
        });
        Object.defineProperty(Cache.prototype, "snapshot", {
            get: function () {
                return {
                    keys: cloneArray(this.keys),
                    size: this.size,
                    values: cloneArray(this.values),
                };
            },
            enumerable: false,
            configurable: true
        });
        /**
         * @function _getKeyIndexFromMatchingKey
         *
         * @description
         * gets the matching key index when a custom key matcher is used
         *
         * @param keyToMatch the key to match
         * @returns the index of the matching key, or -1
         */
        Cache.prototype._getKeyIndexFromMatchingKey = function (keyToMatch) {
            var _a = this.options, isMatchingKey = _a.isMatchingKey, maxSize = _a.maxSize;
            var keys = this.keys;
            var keysLength = keys.length;
            if (!keysLength) {
                return -1;
            }
            if (isMatchingKey(keys[0], keyToMatch)) {
                return 0;
            }
            if (maxSize > 1) {
                for (var index = 1; index < keysLength; index++) {
                    if (isMatchingKey(keys[index], keyToMatch)) {
                        return index;
                    }
                }
            }
            return -1;
        };
        /**
         * @function _getKeyIndexForMany
         *
         * @description
         * gets the matching key index when multiple keys are used
         *
         * @param keyToMatch the key to match
         * @returns the index of the matching key, or -1
         */
        Cache.prototype._getKeyIndexForMany = function (keyToMatch) {
            var isEqual = this.options.isEqual;
            var keys = this.keys;
            var keysLength = keys.length;
            if (!keysLength) {
                return -1;
            }
            if (keysLength === 1) {
                return this._getKeyIndexForSingle(keyToMatch);
            }
            var keyLength = keyToMatch.length;
            var existingKey;
            var argIndex;
            if (keyLength > 1) {
                for (var index = 0; index < keysLength; index++) {
                    existingKey = keys[index];
                    if (existingKey.length === keyLength) {
                        argIndex = 0;
                        for (; argIndex < keyLength; argIndex++) {
                            if (!isEqual(existingKey[argIndex], keyToMatch[argIndex])) {
                                break;
                            }
                        }
                        if (argIndex === keyLength) {
                            return index;
                        }
                    }
                }
            }
            else {
                for (var index = 0; index < keysLength; index++) {
                    existingKey = keys[index];
                    if (existingKey.length === keyLength &&
                        isEqual(existingKey[0], keyToMatch[0])) {
                        return index;
                    }
                }
            }
            return -1;
        };
        /**
         * @function _getKeyIndexForSingle
         *
         * @description
         * gets the matching key index when a single key is used
         *
         * @param keyToMatch the key to match
         * @returns the index of the matching key, or -1
         */
        Cache.prototype._getKeyIndexForSingle = function (keyToMatch) {
            var keys = this.keys;
            if (!keys.length) {
                return -1;
            }
            var existingKey = keys[0];
            var length = existingKey.length;
            if (keyToMatch.length !== length) {
                return -1;
            }
            var isEqual = this.options.isEqual;
            if (length > 1) {
                for (var index = 0; index < length; index++) {
                    if (!isEqual(existingKey[index], keyToMatch[index])) {
                        return -1;
                    }
                }
                return 0;
            }
            return isEqual(existingKey[0], keyToMatch[0]) ? 0 : -1;
        };
        /**
         * @function orderByLru
         *
         * @description
         * order the array based on a Least-Recently-Used basis
         *
         * @param key the new key to move to the front
         * @param value the new value to move to the front
         * @param startingIndex the index of the item to move to the front
         */
        Cache.prototype.orderByLru = function (key, value, startingIndex) {
            var keys = this.keys;
            var values = this.values;
            var currentLength = keys.length;
            var index = startingIndex;
            while (index--) {
                keys[index + 1] = keys[index];
                values[index + 1] = values[index];
            }
            keys[0] = key;
            values[0] = value;
            var maxSize = this.options.maxSize;
            if (currentLength === maxSize && startingIndex === currentLength) {
                keys.pop();
                values.pop();
            }
            else if (startingIndex >= maxSize) {
                // eslint-disable-next-line no-multi-assign
                keys.length = values.length = maxSize;
            }
        };
        /**
         * @function updateAsyncCache
         *
         * @description
         * update the promise method to auto-remove from cache if rejected, and
         * if resolved then fire cache hit / changed
         *
         * @param memoized the memoized function
         */
        Cache.prototype.updateAsyncCache = function (memoized) {
            var _this = this;
            var _a = this.options, onCacheChange = _a.onCacheChange, onCacheHit = _a.onCacheHit;
            var firstKey = this.keys[0];
            var firstValue = this.values[0];
            this.values[0] = firstValue.then(function (value) {
                if (_this.shouldUpdateOnHit) {
                    onCacheHit(_this, _this.options, memoized);
                }
                if (_this.shouldUpdateOnChange) {
                    onCacheChange(_this, _this.options, memoized);
                }
                return value;
            }, function (error) {
                var keyIndex = _this.getKeyIndex(firstKey);
                if (keyIndex !== -1) {
                    _this.keys.splice(keyIndex, 1);
                    _this.values.splice(keyIndex, 1);
                }
                throw error;
            });
        };
        return Cache;
    }());

    // cache
    function createMemoizedFunction(fn, options) {
        if (options === void 0) { options = {}; }
        if (isMemoized(fn)) {
            return createMemoizedFunction(fn.fn, mergeOptions(fn.options, options));
        }
        if (typeof fn !== 'function') {
            throw new TypeError('You must pass a function to `memoize`.');
        }
        var _a = options.isEqual, isEqual = _a === void 0 ? isSameValueZero : _a, isMatchingKey = options.isMatchingKey, _b = options.isPromise, isPromise = _b === void 0 ? false : _b, _c = options.maxSize, maxSize = _c === void 0 ? 1 : _c, onCacheAdd = options.onCacheAdd, onCacheChange = options.onCacheChange, onCacheHit = options.onCacheHit, transformKey = options.transformKey;
        var normalizedOptions = mergeOptions({
            isEqual: isEqual,
            isMatchingKey: isMatchingKey,
            isPromise: isPromise,
            maxSize: maxSize,
            onCacheAdd: onCacheAdd,
            onCacheChange: onCacheChange,
            onCacheHit: onCacheHit,
            transformKey: transformKey,
        }, getCustomOptions(options));
        var cache = new Cache(normalizedOptions);
        var keys = cache.keys, values = cache.values, canTransformKey = cache.canTransformKey, shouldCloneArguments = cache.shouldCloneArguments, shouldUpdateOnAdd = cache.shouldUpdateOnAdd, shouldUpdateOnChange = cache.shouldUpdateOnChange, shouldUpdateOnHit = cache.shouldUpdateOnHit;
        // @ts-ignore
        var memoized = function memoized() {
            // @ts-ignore
            var key = shouldCloneArguments
                ? cloneArray(arguments)
                : arguments;
            if (canTransformKey) {
                key = transformKey(key);
            }
            var keyIndex = keys.length ? cache.getKeyIndex(key) : -1;
            if (keyIndex !== -1) {
                if (shouldUpdateOnHit) {
                    onCacheHit(cache, normalizedOptions, memoized);
                }
                if (keyIndex) {
                    cache.orderByLru(keys[keyIndex], values[keyIndex], keyIndex);
                    if (shouldUpdateOnChange) {
                        onCacheChange(cache, normalizedOptions, memoized);
                    }
                }
            }
            else {
                var newValue = fn.apply(this, arguments);
                var newKey = shouldCloneArguments
                    ? key
                    : cloneArray(arguments);
                cache.orderByLru(newKey, newValue, keys.length);
                if (isPromise) {
                    cache.updateAsyncCache(memoized);
                }
                if (shouldUpdateOnAdd) {
                    onCacheAdd(cache, normalizedOptions, memoized);
                }
                if (shouldUpdateOnChange) {
                    onCacheChange(cache, normalizedOptions, memoized);
                }
            }
            return values[0];
        };
        memoized.cache = cache;
        memoized.fn = fn;
        memoized.isMemoized = true;
        memoized.options = normalizedOptions;
        return memoized;
    }

    return createMemoizedFunction;

}));
//# sourceMappingURL=micro-memoize.js.map


/***/ }),

/***/ 12726:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

(function (global, factory) {
   true ? module.exports = factory(__webpack_require__(42568), __webpack_require__(58367)) :
  0;
})(this, (function (memoize, fastEquals) { 'use strict';

  function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

  var memoize__default = /*#__PURE__*/_interopDefaultLegacy(memoize);

  function _extends() {
    _extends = Object.assign ? Object.assign.bind() : function (target) {
      for (var i = 1; i < arguments.length; i++) {
        var source = arguments[i];

        for (var key in source) {
          if (Object.prototype.hasOwnProperty.call(source, key)) {
            target[key] = source[key];
          }
        }
      }

      return target;
    };
    return _extends.apply(this, arguments);
  }

  function _objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;

    for (i = 0; i < sourceKeys.length; i++) {
      key = sourceKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      target[key] = source[key];
    }

    return target;
  }

  /**
   * @private
   *
   * @constant DEFAULT_OPTIONS
   */
  var DEFAULT_OPTIONS = {
    isDeepEqual: false,
    isPromise: false,
    isReact: false,
    isSerialized: false,
    isShallowEqual: false,
    matchesArg: undefined,
    matchesKey: undefined,
    maxAge: undefined,
    maxArgs: undefined,
    maxSize: 1,
    onExpire: undefined,
    profileName: undefined,
    serializer: undefined,
    updateCacheForKey: undefined,
    transformArgs: undefined,
    updateExpire: false
  };

  /**
   * @private
   *
   * @description
   * method to combine functions and return a single function that fires them all
   *
   * @param functions the functions to compose
   * @returns the composed function
   */
  function combine() {
    for (var _len = arguments.length, functions = new Array(_len), _key = 0; _key < _len; _key++) {
      functions[_key] = arguments[_key];
    }

    return functions.reduce(function (f, g) {
      if (typeof f === 'function') {
        return typeof g === 'function' ? function () {
          f.apply(this, arguments);
          g.apply(this, arguments);
        } : f;
      }

      if (typeof g === 'function') {
        return g;
      }
    });
  }
  /**
   * @private
   *
   * @description
   * method to compose functions and return a single function
   *
   * @param functions the functions to compose
   * @returns the composed function
   */

  function compose() {
    for (var _len2 = arguments.length, functions = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      functions[_key2] = arguments[_key2];
    }

    return functions.reduce(function (f, g) {
      if (typeof f === 'function') {
        return typeof g === 'function' ? function () {
          return f(g.apply(this, arguments));
        } : f;
      }

      if (typeof g === 'function') {
        return g;
      }
    });
  }
  /**
   * @private
   *
   * @description
   * find the index of the expiration based on the key
   *
   * @param expirations the list of expirations
   * @param key the key to match
   * @returns the index of the expiration
   */

  function findExpirationIndex(expirations, key) {
    for (var index = 0; index < expirations.length; index++) {
      if (expirations[index].key === key) {
        return index;
      }
    }

    return -1;
  }
  /**
   * @private
   *
   * @description
   * create function that finds the index of the key in the list of cache keys
   *
   * @param isEqual the function to test individual argument equality
   * @param isMatchingKey the function to test full key equality
   * @returns the function that finds the index of the key
   */

  function createFindKeyIndex(isEqual, isMatchingKey) {
    var areKeysEqual = typeof isMatchingKey === 'function' ? isMatchingKey : function (cacheKey, key) {
      for (var index = 0; index < key.length; index++) {
        if (!isEqual(cacheKey[index], key[index])) {
          return false;
        }
      }

      return true;
    };
    return function (keys, key) {
      for (var keysIndex = 0; keysIndex < keys.length; keysIndex++) {
        if (keys[keysIndex].length === key.length && areKeysEqual(keys[keysIndex], key)) {
          return keysIndex;
        }
      }

      return -1;
    };
  }
  /**
   * @private
   *
   * @description
   * merge two options objects, combining or composing functions as necessary
   *
   * @param originalOptions the options that already exist on the method
   * @param newOptions the new options to merge
   * @returns the merged options
   */

  function mergeOptions(originalOptions, newOptions) {
    return !newOptions || newOptions === DEFAULT_OPTIONS ? originalOptions : _extends({}, originalOptions, newOptions, {
      onCacheAdd: combine(originalOptions.onCacheAdd, newOptions.onCacheAdd),
      onCacheChange: combine(originalOptions.onCacheChange, newOptions.onCacheChange),
      onCacheHit: combine(originalOptions.onCacheHit, newOptions.onCacheHit),
      transformArgs: compose(originalOptions.transformArgs, newOptions.transformArgs)
    });
  }
  function isMoized(fn) {
    return typeof fn === 'function' && fn.isMoized;
  }
  function setName(fn, originalFunctionName, profileName) {
    try {
      var name = profileName || originalFunctionName || 'anonymous';
      Object.defineProperty(fn, 'name', {
        configurable: true,
        enumerable: false,
        value: "moized(" + name + ")",
        writable: true
      });
    } catch (_unused) {// For engines where `function.name` is not configurable, do nothing.
    }
  }

  /**
   * @private
   *
   * @description
   * clear an active expiration and remove it from the list if applicable
   *
   * @param expirations the list of expirations
   * @param key the key to clear
   * @param shouldRemove should the expiration be removed from the list
   */

  function clearExpiration(expirations, key, shouldRemove) {
    var expirationIndex = findExpirationIndex(expirations, key);

    if (expirationIndex !== -1) {
      clearTimeout(expirations[expirationIndex].timeoutId);

      if (shouldRemove) {
        expirations.splice(expirationIndex, 1);
      }
    }
  }
  /**
   * @private
   *
   * @description
   * Create the timeout for the given expiration method. If the ability to `unref`
   * exists, then apply it to avoid process locks in NodeJS.
   *
   * @param expirationMethod the method to fire upon expiration
   * @param maxAge the time to expire after
   * @returns the timeout ID
   */

  function createTimeout(expirationMethod, maxAge) {
    var timeoutId = setTimeout(expirationMethod, maxAge);

    if (typeof timeoutId.unref === 'function') {
      timeoutId.unref();
    }

    return timeoutId;
  }
  /**
   * @private
   *
   * @description
   * create a function that, when an item is added to the cache, adds an expiration for it
   *
   * @param expirations the mutable expirations array
   * @param options the options passed on initialization
   * @param isEqual the function to check argument equality
   * @param isMatchingKey the function to check complete key equality
   * @returns the onCacheAdd function to handle expirations
   */

  function createOnCacheAddSetExpiration(expirations, options, isEqual, isMatchingKey) {
    var maxAge = options.maxAge;
    return function onCacheAdd(cache, moizedOptions, moized) {
      var key = cache.keys[0];

      if (findExpirationIndex(expirations, key) === -1) {
        var expirationMethod = function expirationMethod() {
          var findKeyIndex = createFindKeyIndex(isEqual, isMatchingKey);
          var keyIndex = findKeyIndex(cache.keys, key);
          var value = cache.values[keyIndex];

          if (~keyIndex) {
            cache.keys.splice(keyIndex, 1);
            cache.values.splice(keyIndex, 1);

            if (typeof options.onCacheChange === 'function') {
              options.onCacheChange(cache, moizedOptions, moized);
            }
          }

          clearExpiration(expirations, key, true);

          if (typeof options.onExpire === 'function' && options.onExpire(key) === false) {
            cache.keys.unshift(key);
            cache.values.unshift(value);
            onCacheAdd(cache, moizedOptions, moized);

            if (typeof options.onCacheChange === 'function') {
              options.onCacheChange(cache, moizedOptions, moized);
            }
          }
        };

        expirations.push({
          expirationMethod: expirationMethod,
          key: key,
          timeoutId: createTimeout(expirationMethod, maxAge)
        });
      }
    };
  }
  /**
   * @private
   *
   * @description
   * creates a function that, when a cache item is hit, reset the expiration
   *
   * @param expirations the mutable expirations array
   * @param options the options passed on initialization
   * @returns the onCacheAdd function to handle expirations
   */

  function createOnCacheHitResetExpiration(expirations, options) {
    return function onCacheHit(cache) {
      var key = cache.keys[0];
      var expirationIndex = findExpirationIndex(expirations, key);

      if (~expirationIndex) {
        clearExpiration(expirations, key, false);
        expirations[expirationIndex].timeoutId = createTimeout(expirations[expirationIndex].expirationMethod, options.maxAge);
      }
    };
  }
  /**
   * @private
   *
   * @description
   * get the micro-memoize options specific to the maxAge option
   *
   * @param expirations the expirations for the memoized function
   * @param options the options passed to the moizer
   * @param isEqual the function to test equality of the key on a per-argument basis
   * @param isMatchingKey the function to test equality of the whole key
   * @returns the object of options based on the entries passed
   */

  function getMaxAgeOptions(expirations, options, isEqual, isMatchingKey) {
    var onCacheAdd = typeof options.maxAge === 'number' && isFinite(options.maxAge) ? createOnCacheAddSetExpiration(expirations, options, isEqual, isMatchingKey) : undefined;
    return {
      onCacheAdd: onCacheAdd,
      onCacheHit: onCacheAdd && options.updateExpire ? createOnCacheHitResetExpiration(expirations, options) : undefined
    };
  }

  var statsCache = {
    anonymousProfileNameCounter: 1,
    isCollectingStats: false,
    profiles: {}
  };
  var hasWarningDisplayed = false;
  function clearStats(profileName) {
    if (profileName) {
      delete statsCache.profiles[profileName];
    } else {
      statsCache.profiles = {};
    }
  }
  /**
   * @private
   *
   * @description
   * activate stats collection
   *
   * @param isCollectingStats should stats be collected
   */

  function collectStats(isCollectingStats) {
    if (isCollectingStats === void 0) {
      isCollectingStats = true;
    }

    statsCache.isCollectingStats = isCollectingStats;
  }
  /**
   * @private
   *
   * @description
   * create a function that increments the number of calls for the specific profile
   */

  function createOnCacheAddIncrementCalls(options) {
    var profileName = options.profileName;
    return function () {
      if (profileName && !statsCache.profiles[profileName]) {
        statsCache.profiles[profileName] = {
          calls: 0,
          hits: 0
        };
      }

      statsCache.profiles[profileName].calls++;
    };
  }
  /**
   * @private
   *
   * @description
   * create a function that increments the number of calls and cache hits for the specific profile
   */

  function createOnCacheHitIncrementCallsAndHits(options) {
    return function () {
      var profiles = statsCache.profiles;
      var profileName = options.profileName;

      if (!profiles[profileName]) {
        profiles[profileName] = {
          calls: 0,
          hits: 0
        };
      }

      profiles[profileName].calls++;
      profiles[profileName].hits++;
    };
  }
  /**
   * @private
   *
   * @description
   * get the profileName for the function when one is not provided
   *
   * @param fn the function to be memoized
   * @returns the derived profileName for the function
   */

  function getDefaultProfileName(fn) {
    return fn.displayName || fn.name || "Anonymous " + statsCache.anonymousProfileNameCounter++;
  }
  /**
   * @private
   *
   * @description
   * get the usage percentage based on the number of hits and total calls
   *
   * @param calls the number of calls made
   * @param hits the number of cache hits when called
   * @returns the usage as a percentage string
   */

  function getUsagePercentage(calls, hits) {
    return calls ? (hits / calls * 100).toFixed(4) + "%" : '0.0000%';
  }
  /**
   * @private
   *
   * @description
   * get the statistics for a given method or all methods
   *
   * @param [profileName] the profileName to get the statistics for (get all when not provided)
   * @returns the object with stats information
   */

  function getStats(profileName) {
    if (!statsCache.isCollectingStats && !hasWarningDisplayed) {
      console.warn('Stats are not currently being collected, please run "collectStats" to enable them.'); // eslint-disable-line no-console

      hasWarningDisplayed = true;
    }

    var profiles = statsCache.profiles;

    if (profileName) {
      if (!profiles[profileName]) {
        return {
          calls: 0,
          hits: 0,
          usage: '0.0000%'
        };
      }

      var profile = profiles[profileName];
      return _extends({}, profile, {
        usage: getUsagePercentage(profile.calls, profile.hits)
      });
    }

    var completeStats = Object.keys(statsCache.profiles).reduce(function (completeProfiles, profileName) {
      completeProfiles.calls += profiles[profileName].calls;
      completeProfiles.hits += profiles[profileName].hits;
      return completeProfiles;
    }, {
      calls: 0,
      hits: 0
    });
    return _extends({}, completeStats, {
      profiles: Object.keys(profiles).reduce(function (computedProfiles, profileName) {
        computedProfiles[profileName] = getStats(profileName);
        return computedProfiles;
      }, {}),
      usage: getUsagePercentage(completeStats.calls, completeStats.hits)
    });
  }
  /**
   * @private
   *
   * @function getStatsOptions
   *
   * @description
   * get the options specific to storing statistics
   *
   * @param {Options} options the options passed to the moizer
   * @returns {Object} the options specific to keeping stats
   */

  function getStatsOptions(options) {
    return statsCache.isCollectingStats ? {
      onCacheAdd: createOnCacheAddIncrementCalls(options),
      onCacheHit: createOnCacheHitIncrementCallsAndHits(options)
    } : {};
  }

  var ALWAYS_SKIPPED_PROPERTIES = {
    arguments: true,
    callee: true,
    caller: true,
    constructor: true,
    length: true,
    name: true,
    prototype: true
  };
  /**
   * @private
   *
   * @description
   * copy the static properties from the original function to the moized
   * function
   *
   * @param originalFn the function copying from
   * @param newFn the function copying to
   * @param skippedProperties the list of skipped properties, if any
   */

  function copyStaticProperties(originalFn, newFn, skippedProperties) {
    if (skippedProperties === void 0) {
      skippedProperties = [];
    }

    Object.getOwnPropertyNames(originalFn).forEach(function (property) {
      if (!ALWAYS_SKIPPED_PROPERTIES[property] && skippedProperties.indexOf(property) === -1) {
        var descriptor = Object.getOwnPropertyDescriptor(originalFn, property);

        if (descriptor.get || descriptor.set) {
          Object.defineProperty(newFn, property, descriptor);
        } else {
          newFn[property] = originalFn[property];
        }
      }
    });
  }
  /**
   * @private
   *
   * @description
   * add methods to the moized fuction object that allow extra features
   *
   * @param memoized the memoized function from micro-memoize
   */

  function addInstanceMethods(memoized, _ref) {
    var expirations = _ref.expirations;
    var options = memoized.options;
    var findKeyIndex = createFindKeyIndex(options.isEqual, options.isMatchingKey);
    var moized = memoized;

    moized.clear = function () {
      var onCacheChange = moized._microMemoizeOptions.onCacheChange,
          cache = moized.cache;
      cache.keys.length = 0;
      cache.values.length = 0;

      if (onCacheChange) {
        onCacheChange(cache, moized.options, moized);
      }

      return true;
    };

    moized.clearStats = function () {
      clearStats(moized.options.profileName);
    };

    moized.get = function (key) {
      var transformKey = moized._microMemoizeOptions.transformKey,
          cache = moized.cache;
      var cacheKey = transformKey ? transformKey(key) : key;
      var keyIndex = findKeyIndex(cache.keys, cacheKey);
      return keyIndex !== -1 ? moized.apply(this, key) : undefined;
    };

    moized.getStats = function () {
      return getStats(moized.options.profileName);
    };

    moized.has = function (key) {
      var transformKey = moized._microMemoizeOptions.transformKey;
      var cacheKey = transformKey ? transformKey(key) : key;
      return findKeyIndex(moized.cache.keys, cacheKey) !== -1;
    };

    moized.keys = function () {
      return moized.cacheSnapshot.keys;
    };

    moized.remove = function (key) {
      var _moized$_microMemoize = moized._microMemoizeOptions,
          onCacheChange = _moized$_microMemoize.onCacheChange,
          transformKey = _moized$_microMemoize.transformKey,
          cache = moized.cache;
      var keyIndex = findKeyIndex(cache.keys, transformKey ? transformKey(key) : key);

      if (keyIndex === -1) {
        return false;
      }

      var existingKey = cache.keys[keyIndex];
      cache.keys.splice(keyIndex, 1);
      cache.values.splice(keyIndex, 1);

      if (onCacheChange) {
        onCacheChange(cache, moized.options, moized);
      }

      clearExpiration(expirations, existingKey, true);
      return true;
    };

    moized.set = function (key, value) {
      var _microMemoizeOptions = moized._microMemoizeOptions,
          cache = moized.cache,
          options = moized.options;
      var onCacheAdd = _microMemoizeOptions.onCacheAdd,
          onCacheChange = _microMemoizeOptions.onCacheChange,
          transformKey = _microMemoizeOptions.transformKey;
      var cacheKey = transformKey ? transformKey(key) : key;
      var keyIndex = findKeyIndex(cache.keys, cacheKey);

      if (keyIndex === -1) {
        var cutoff = options.maxSize - 1;

        if (cache.size > cutoff) {
          cache.keys.length = cutoff;
          cache.values.length = cutoff;
        }

        cache.keys.unshift(cacheKey);
        cache.values.unshift(value);

        if (options.isPromise) {
          cache.updateAsyncCache(moized);
        }

        if (onCacheAdd) {
          onCacheAdd(cache, options, moized);
        }

        if (onCacheChange) {
          onCacheChange(cache, options, moized);
        }
      } else {
        var existingKey = cache.keys[keyIndex];
        cache.values[keyIndex] = value;

        if (keyIndex > 0) {
          cache.orderByLru(existingKey, value, keyIndex);
        }

        if (options.isPromise) {
          cache.updateAsyncCache(moized);
        }

        if (typeof onCacheChange === 'function') {
          onCacheChange(cache, options, moized);
        }
      }
    };

    moized.values = function () {
      return moized.cacheSnapshot.values;
    };
  }
  /**
   * @private
   *
   * @description
   * add propeties to the moized fuction object that surfaces extra information
   *
   * @param memoized the memoized function
   * @param expirations the list of expirations for cache items
   * @param options the options passed to the moizer
   * @param originalFunction the function that is being memoized
   */

  function addInstanceProperties(memoized, _ref2) {
    var expirations = _ref2.expirations,
        moizeOptions = _ref2.options,
        originalFunction = _ref2.originalFunction;
    var microMemoizeOptions = memoized.options;
    Object.defineProperties(memoized, {
      _microMemoizeOptions: {
        configurable: true,
        get: function get() {
          return microMemoizeOptions;
        }
      },
      cacheSnapshot: {
        configurable: true,
        get: function get() {
          var currentCache = memoized.cache;
          return {
            keys: currentCache.keys.slice(0),
            size: currentCache.size,
            values: currentCache.values.slice(0)
          };
        }
      },
      expirations: {
        configurable: true,
        get: function get() {
          return expirations;
        }
      },
      expirationsSnapshot: {
        configurable: true,
        get: function get() {
          return expirations.slice(0);
        }
      },
      isMoized: {
        configurable: true,
        get: function get() {
          return true;
        }
      },
      options: {
        configurable: true,
        get: function get() {
          return moizeOptions;
        }
      },
      originalFunction: {
        configurable: true,
        get: function get() {
          return originalFunction;
        }
      }
    });
    var moized = memoized;
    copyStaticProperties(originalFunction, moized);
  }
  /**
   * @private
   *
   * @description
   * add methods and properties to the memoized function for more features
   *
   * @param memoized the memoized function
   * @param configuration the configuration object for the instance
   * @returns the memoized function passed
   */

  function createMoizeInstance(memoized, configuration) {
    addInstanceMethods(memoized, configuration);
    addInstanceProperties(memoized, configuration);
    return memoized;
  }

  // a dependency on the React library itself.

  var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol.for ? Symbol.for('react.element') : 0xeac7;
  /**
   * @private
   *
   * @description
   * Create a component that memoizes based on `props` and legacy `context`
   * on a per-instance basis. This requires creating a component class to
   * store the memoized function. The cost is quite low, and avoids the
   * need to have access to the React dependency by basically re-creating
   * the basic essentials for a component class and the results of the
   * `createElement` function.
   *
   * @param moizer the top-level moize method
   * @param fn the component to memoize
   * @param options the memoization options
   * @returns the memoized component
   */

  function createMoizedComponent(moizer, fn, options) {
    /**
     * This is a hack override setting the necessary options
     * for a React component to be memoized. In the main `moize`
     * method, if the `isReact` option is set it is short-circuited
     * to call this function, and these overrides allow the
     * necessary transformKey method to be derived.
     *
     * The order is based on:
     * 1) Set the necessary aspects of transformKey for React components.
     * 2) Allow setting of other options and overrides of those aspects
     *    if desired (for example, `isDeepEqual` will use deep equality).
     * 3) Always set `isReact` to false to prevent infinite loop.
     */
    var reactMoizer = moizer(_extends({
      maxArgs: 2,
      isShallowEqual: true
    }, options, {
      isReact: false
    }));

    if (!fn.displayName) {
      // @ts-ignore - allow setting of displayName
      fn.displayName = fn.name || 'Component';
    }

    function Moized(props, context, updater) {
      this.props = props;
      this.context = context;
      this.updater = updater;
      this.MoizedComponent = reactMoizer(fn);
    }

    Moized.prototype.isReactComponent = {};

    Moized.prototype.render = function () {
      return {
        $$typeof: REACT_ELEMENT_TYPE,
        type: this.MoizedComponent,
        props: this.props,
        ref: null,
        key: null,
        _owner: null
      };
    };

    copyStaticProperties(fn, Moized, ['contextType', 'contextTypes']);
    Moized.displayName = "Moized(" + (fn.displayName || fn.name || 'Component') + ")";
    setName(Moized, fn.name, options.profileName);
    return Moized;
  }

  function createGetInitialArgs(size) {
    /**
     * @private
     *
     * @description
     * take the first N number of items from the array (faster than slice)
     *
     * @param args the args to take from
     * @returns the shortened list of args as an array
     */
    return function (args) {
      if (size >= args.length) {
        return args;
      }

      if (size === 0) {
        return [];
      }

      if (size === 1) {
        return [args[0]];
      }

      if (size === 2) {
        return [args[0], args[1]];
      }

      if (size === 3) {
        return [args[0], args[1], args[2]];
      }

      var clone = [];

      for (var index = 0; index < size; index++) {
        clone[index] = args[index];
      }

      return clone;
    };
  }

  /**
   * @function getCutoff
   *
   * @description
   * faster `Array.prototype.indexOf` implementation build for slicing / splicing
   *
   * @param array the array to match the value in
   * @param value the value to match
   * @returns the matching index, or -1
   */
  function getCutoff(array, value) {
    var length = array.length;

    for (var index = 0; index < length; ++index) {
      if (array[index] === value) {
        return index + 1;
      }
    }

    return 0;
  }
  /**
   * @private
   *
   * @description
   * custom replacer for the stringify function
   *
   * @returns if function then toString of it, else the value itself
   */


  function createDefaultReplacer() {
    var cache = [];
    var keys = [];
    return function defaultReplacer(key, value) {
      var type = typeof value;

      if (type === 'function' || type === 'symbol') {
        return value.toString();
      }

      if (typeof value === 'object') {
        if (cache.length) {
          var thisCutoff = getCutoff(cache, this);

          if (thisCutoff === 0) {
            cache[cache.length] = this;
          } else {
            cache.splice(thisCutoff);
            keys.splice(thisCutoff);
          }

          keys[keys.length] = key;
          var valueCutoff = getCutoff(cache, value);

          if (valueCutoff !== 0) {
            return "[ref=" + (keys.slice(0, valueCutoff).join('.') || '.') + "]";
          }
        } else {
          cache[0] = value;
          keys[0] = key;
        }

        return value;
      }

      return '' + value;
    };
  }
  /**
   * @private
   *
   * @description
   * get the stringified version of the argument passed
   *
   * @param arg argument to stringify
   * @returns the stringified argument
   */

  function getStringifiedArgument(arg) {
    var typeOfArg = typeof arg;
    return arg && (typeOfArg === 'object' || typeOfArg === 'function') ? JSON.stringify(arg, createDefaultReplacer()) : arg;
  }
  /**
   * @private
   *
   * @description
   * serialize the arguments passed
   *
   * @param options the options passed to the moizer
   * @param options.maxArgs the cap on the number of arguments used in serialization
   * @returns argument serialization method
   */

  function defaultArgumentSerializer(args) {
    var key = '|';

    for (var index = 0; index < args.length; index++) {
      key += getStringifiedArgument(args[index]) + '|';
    }

    return [key];
  }
  /**
   * @private
   *
   * @description
   * based on the options passed, either use the serializer passed or generate the internal one
   *
   * @param options the options passed to the moized function
   * @returns the function to use in serializing the arguments
   */

  function getSerializerFunction(options) {
    return typeof options.serializer === 'function' ? options.serializer : defaultArgumentSerializer;
  }
  /**
   * @private
   *
   * @description
   * are the serialized keys equal to one another
   *
   * @param cacheKey the cache key to compare
   * @param key the key to test
   * @returns are the keys equal
   */

  function getIsSerializedKeyEqual(cacheKey, key) {
    return cacheKey[0] === key[0];
  }

  function createOnCacheOperation(fn) {
    if (typeof fn === 'function') {
      return function (_cacheIgnored, _microMemoizeOptionsIgnored, memoized) {
        return fn(memoized.cache, memoized.options, memoized);
      };
    }
  }
  /**
   * @private
   *
   * @description
   * get the isEqual method passed to micro-memoize
   *
   * @param options the options passed to the moizer
   * @returns the isEqual method to apply
   */

  function getIsEqual(options) {
    return options.matchesArg || options.isDeepEqual && fastEquals.deepEqual || options.isShallowEqual && fastEquals.shallowEqual || fastEquals.sameValueZeroEqual;
  }
  /**
   * @private
   *
   * @description
   * get the isEqual method passed to micro-memoize
   *
   * @param options the options passed to the moizer
   * @returns the isEqual method to apply
   */

  function getIsMatchingKey(options) {
    return options.matchesKey || options.isSerialized && getIsSerializedKeyEqual || undefined;
  }
  /**
   * @private
   *
   * @description
   * get the function that will transform the key based on the arguments passed
   *
   * @param options the options passed to the moizer
   * @returns the function to transform the key with
   */

  function getTransformKey(options) {
    return compose(options.isSerialized && getSerializerFunction(options), typeof options.transformArgs === 'function' && options.transformArgs, typeof options.maxArgs === 'number' && createGetInitialArgs(options.maxArgs));
  }

  function createRefreshableMoized(moized) {
    var updateCacheForKey = moized.options.updateCacheForKey;
    /**
     * @private
     *
     * @description
     * Wrapper around already-`moize`d function which will intercept the memoization
     * and call the underlying function directly with the purpose of updating the cache
     * for the given key.
     *
     * Promise values use a tweak of the logic that exists at cache.updateAsyncCache, which
     * reverts to the original value if the promise is rejected and there was already a cached
     * value.
     */

    var refreshableMoized = function refreshableMoized() {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (!updateCacheForKey(args)) {
        return moized.apply(this, args);
      }

      var result = moized.fn.apply(this, args);
      moized.set(args, result);
      return result;
    };

    copyStaticProperties(moized, refreshableMoized);
    return refreshableMoized;
  }

  var _excluded = ["matchesArg", "isDeepEqual", "isPromise", "isReact", "isSerialized", "isShallowEqual", "matchesKey", "maxAge", "maxArgs", "maxSize", "onCacheAdd", "onCacheChange", "onCacheHit", "onExpire", "profileName", "serializer", "updateCacheForKey", "transformArgs", "updateExpire"];
  /**
   * @module moize
   */

  /**
   * @description
   * memoize a function based its arguments passed, potentially improving runtime performance
   *
   * @example
   * import moize from 'moize';
   *
   * // standard implementation
   * const fn = (foo, bar) => `${foo} ${bar}`;
   * const memoizedFn = moize(fn);
   *
   * // implementation with options
   * const fn = async (id) => get(`http://foo.com/${id}`);
   * const memoizedFn = moize(fn, {isPromise: true, maxSize: 5});
   *
   * // implementation with convenience methods
   * const Foo = ({foo}) => <div>{foo}</div>;
   * const MemoizedFoo = moize.react(Foo);
   *
   * @param fn the function to memoized, or a list of options when currying
   * @param [options=DEFAULT_OPTIONS] the options to apply
   * @returns the memoized function
   */

  var moize = function moize(fn, passedOptions) {
    var options = passedOptions || DEFAULT_OPTIONS;

    if (isMoized(fn)) {
      var moizeable = fn.originalFunction;
      var mergedOptions = mergeOptions(fn.options, options);
      return moize(moizeable, mergedOptions);
    }

    if (typeof fn === 'object') {
      return function (curriedFn, curriedOptions) {
        if (typeof curriedFn === 'function') {
          var _mergedOptions = mergeOptions(fn, curriedOptions);

          return moize(curriedFn, _mergedOptions);
        }

        var mergedOptions = mergeOptions(fn, curriedFn);
        return moize(mergedOptions);
      };
    }

    if (options.isReact) {
      return createMoizedComponent(moize, fn, options);
    }

    var coalescedOptions = _extends({}, DEFAULT_OPTIONS, options, {
      maxAge: typeof options.maxAge === 'number' && options.maxAge >= 0 ? options.maxAge : DEFAULT_OPTIONS.maxAge,
      maxArgs: typeof options.maxArgs === 'number' && options.maxArgs >= 0 ? options.maxArgs : DEFAULT_OPTIONS.maxArgs,
      maxSize: typeof options.maxSize === 'number' && options.maxSize >= 0 ? options.maxSize : DEFAULT_OPTIONS.maxSize,
      profileName: options.profileName || getDefaultProfileName(fn)
    });

    var expirations = [];

    coalescedOptions.matchesArg;
        coalescedOptions.isDeepEqual;
        var isPromise = coalescedOptions.isPromise;
        coalescedOptions.isReact;
        coalescedOptions.isSerialized;
        coalescedOptions.isShallowEqual;
        coalescedOptions.matchesKey;
        coalescedOptions.maxAge;
        coalescedOptions.maxArgs;
        var maxSize = coalescedOptions.maxSize,
        onCacheAdd = coalescedOptions.onCacheAdd,
        onCacheChange = coalescedOptions.onCacheChange,
        onCacheHit = coalescedOptions.onCacheHit;
        coalescedOptions.onExpire;
        coalescedOptions.profileName;
        coalescedOptions.serializer;
        var updateCacheForKey = coalescedOptions.updateCacheForKey;
        coalescedOptions.transformArgs;
        coalescedOptions.updateExpire;
        var customOptions = _objectWithoutPropertiesLoose(coalescedOptions, _excluded);

    var isEqual = getIsEqual(coalescedOptions);
    var isMatchingKey = getIsMatchingKey(coalescedOptions);
    var maxAgeOptions = getMaxAgeOptions(expirations, coalescedOptions, isEqual, isMatchingKey);
    var statsOptions = getStatsOptions(coalescedOptions);
    var transformKey = getTransformKey(coalescedOptions);

    var microMemoizeOptions = _extends({}, customOptions, {
      isEqual: isEqual,
      isMatchingKey: isMatchingKey,
      isPromise: isPromise,
      maxSize: maxSize,
      onCacheAdd: createOnCacheOperation(combine(onCacheAdd, maxAgeOptions.onCacheAdd, statsOptions.onCacheAdd)),
      onCacheChange: createOnCacheOperation(onCacheChange),
      onCacheHit: createOnCacheOperation(combine(onCacheHit, maxAgeOptions.onCacheHit, statsOptions.onCacheHit)),
      transformKey: transformKey
    });

    var memoized = memoize__default["default"](fn, microMemoizeOptions);
    var moized = createMoizeInstance(memoized, {
      expirations: expirations,
      options: coalescedOptions,
      originalFunction: fn
    });

    if (updateCacheForKey) {
      moized = createRefreshableMoized(moized);
    }

    setName(moized, fn.name, options.profileName);
    return moized;
  };
  /**
   * @function
   * @name clearStats
   * @memberof module:moize
   * @alias moize.clearStats
   *
   * @description
   * clear all existing stats stored
   */


  moize.clearStats = clearStats;
  /**
   * @function
   * @name collectStats
   * @memberof module:moize
   * @alias moize.collectStats
   *
   * @description
   * start collecting statistics
   */

  moize.collectStats = collectStats;
  /**
   * @function
   * @name compose
   * @memberof module:moize
   * @alias moize.compose
   *
   * @description
   * method to compose moized methods and return a single moized function
   *
   * @param moized the functions to compose
   * @returns the composed function
   */

  moize.compose = function () {
    return compose.apply(void 0, arguments) || moize;
  };
  /**
   * @function
   * @name deep
   * @memberof module:moize
   * @alias moize.deep
   *
   * @description
   * should deep equality check be used
   *
   * @returns the moizer function
   */


  moize.deep = moize({
    isDeepEqual: true
  });
  /**
   * @function
   * @name getStats
   * @memberof module:moize
   * @alias moize.getStats
   *
   * @description
   * get the statistics of a given profile, or overall usage
   *
   * @returns statistics for a given profile or overall usage
   */

  moize.getStats = getStats;
  /**
   * @function
   * @name infinite
   * @memberof module:moize
   * @alias moize.infinite
   *
   * @description
   * a moized method that will remove all limits from the cache size
   *
   * @returns the moizer function
   */

  moize.infinite = moize({
    maxSize: Infinity
  });
  /**
   * @function
   * @name isCollectingStats
   * @memberof module:moize
   * @alias moize.isCollectingStats
   *
   * @description
   * are stats being collected
   *
   * @returns are stats being collected
   */

  moize.isCollectingStats = function isCollectingStats() {
    return statsCache.isCollectingStats;
  };
  /**
   * @function
   * @name isMoized
   * @memberof module:moize
   * @alias moize.isMoized
   *
   * @description
   * is the fn passed a moized function
   *
   * @param fn the object to test
   * @returns is fn a moized function
   */


  moize.isMoized = function isMoized(fn) {
    return typeof fn === 'function' && !!fn.isMoized;
  };
  /**
   * @function
   * @name matchesArg
   * @memberof module:moize
   * @alias moize.matchesArg
   *
   * @description
   * a moized method where the arg matching method is the custom one passed
   *
   * @param keyMatcher the method to compare against those in cache
   * @returns the moizer function
   */


  moize.matchesArg = function (argMatcher) {
    return moize({
      matchesArg: argMatcher
    });
  };
  /**
   * @function
   * @name matchesKey
   * @memberof module:moize
   * @alias moize.matchesKey
   *
   * @description
   * a moized method where the key matching method is the custom one passed
   *
   * @param keyMatcher the method to compare against those in cache
   * @returns the moizer function
   */


  moize.matchesKey = function (keyMatcher) {
    return moize({
      matchesKey: keyMatcher
    });
  };

  function maxAge(maxAge, expireOptions) {
    if (expireOptions === true) {
      return moize({
        maxAge: maxAge,
        updateExpire: expireOptions
      });
    }

    if (typeof expireOptions === 'object') {
      var onExpire = expireOptions.onExpire,
          updateExpire = expireOptions.updateExpire;
      return moize({
        maxAge: maxAge,
        onExpire: onExpire,
        updateExpire: updateExpire
      });
    }

    if (typeof expireOptions === 'function') {
      return moize({
        maxAge: maxAge,
        onExpire: expireOptions,
        updateExpire: true
      });
    }

    return moize({
      maxAge: maxAge
    });
  }
  /**
   * @function
   * @name maxAge
   * @memberof module:moize
   * @alias moize.maxAge
   *
   * @description
   * a moized method where the age of the cache is limited to the number of milliseconds passed
   *
   * @param maxAge the TTL of the value in cache
   * @returns the moizer function
   */


  moize.maxAge = maxAge;
  /**
   * @function
   * @name maxArgs
   * @memberof module:moize
   * @alias moize.maxArgs
   *
   * @description
   * a moized method where the number of arguments used for determining cache is limited to the value passed
   *
   * @param maxArgs the number of args to base the key on
   * @returns the moizer function
   */

  moize.maxArgs = function maxArgs(maxArgs) {
    return moize({
      maxArgs: maxArgs
    });
  };
  /**
   * @function
   * @name maxSize
   * @memberof module:moize
   * @alias moize.maxSize
   *
   * @description
   * a moized method where the total size of the cache is limited to the value passed
   *
   * @param maxSize the maximum size of the cache
   * @returns the moizer function
   */


  moize.maxSize = function maxSize(maxSize) {
    return moize({
      maxSize: maxSize
    });
  };
  /**
   * @function
   * @name profile
   * @memberof module:moize
   * @alias moize.profile
   *
   * @description
   * a moized method with a profile name
   *
   * @returns the moizer function
   */


  moize.profile = function (profileName) {
    return moize({
      profileName: profileName
    });
  };
  /**
   * @function
   * @name promise
   * @memberof module:moize
   * @alias moize.promise
   *
   * @description
   * a moized method specific to caching resolved promise / async values
   *
   * @returns the moizer function
   */


  moize.promise = moize({
    isPromise: true,
    updateExpire: true
  });
  /**
   * @function
   * @name react
   * @memberof module:moize
   * @alias moize.react
   *
   * @description
   * a moized method specific to caching React element values
   *
   * @returns the moizer function
   */

  moize.react = moize({
    isReact: true
  });
  /**
   * @function
   * @name serialize
   * @memberof module:moize
   * @alias moize.serialize
   *
   * @description
   * a moized method that will serialize the arguments passed to use as the cache key
   *
   * @returns the moizer function
   */

  moize.serialize = moize({
    isSerialized: true
  });
  /**
   * @function
   * @name serializeWith
   * @memberof module:moize
   * @alias moize.serializeWith
   *
   * @description
   * a moized method that will serialize the arguments passed to use as the cache key
   * based on the serializer passed
   *
   * @returns the moizer function
   */

  moize.serializeWith = function (serializer) {
    return moize({
      isSerialized: true,
      serializer: serializer
    });
  };
  /**
   * @function
   * @name shallow
   * @memberof module:moize
   * @alias moize.shallow
   *
   * @description
   * should shallow equality check be used
   *
   * @returns the moizer function
   */


  moize.shallow = moize({
    isShallowEqual: true
  });
  /**
   * @function
   * @name transformArgs
   * @memberof module:moize
   * @alias moize.transformArgs
   *
   * @description
   * transform the args to allow for specific cache key comparison
   *
   * @param transformArgs the args transformer
   * @returns the moizer function
   */

  moize.transformArgs = function (transformArgs) {
    return moize({
      transformArgs: transformArgs
    });
  };
  /**
   * @function
   * @name updateCacheForKey
   * @memberof module:moize
   * @alias moize.updateCacheForKey
   *
   * @description
   * update the cache for a given key when the method passed returns truthy
   *
   * @param updateCacheForKey the method to determine when to update cache
   * @returns the moizer function
   */


  moize.updateCacheForKey = function (updateCacheForKey) {
    return moize({
      updateCacheForKey: updateCacheForKey
    });
  }; // Add self-referring `default` property for edge-case cross-compatibility of mixed ESM/CommonJS usage.
  // This property is frozen and non-enumerable to avoid visibility on iteration or accidental overrides.


  Object.defineProperty(moize, 'default', {
    configurable: false,
    enumerable: false,
    value: moize,
    writable: false
  });

  return moize;

}));
//# sourceMappingURL=moize.js.map


/***/ }),

/***/ 88939:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var moize__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12726);
/* harmony import */ var moize__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(moize__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(8690);
/* harmony import */ var prop_types__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(prop_types__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var styled_system__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(99278);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87379);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92591);
/* harmony import */ var ___WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92833);
var __makeTemplateObject = (undefined && undefined.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};






/**
 * Returns an array of values with the same length as numChildren with each item
 * set to the corresponding value in the variation string. If numChildren is greater than
 * the number of digits in variation, the same variation values will be repeated.
 * @param variationWidth - variation string
 * @param numChildren - number of children
 * @returns
 */
var getNonhomogeneousWidths = function (variationWidth, numChildren) {
    var variationWidths = variationWidth.split('-').map(function (width) { return parseInt(width, 10); });
    var widths = [];
    for (var i = 0; i < numChildren; i++) {
        widths.push(variationWidths[i % variationWidths.length] / 100);
    }
    return widths;
};
var getWidthsForVariation = function (variation, numChildren) {
    if (!variation) {
        return null;
    }
    if (variation === '50-50') {
        return Array(numChildren).fill(1 / 2);
    }
    else if (variation === '33-33-33') {
        return Array(numChildren).fill(1 / 3);
    }
    else if (variation === '25-25-25-25') {
        return Array(numChildren).fill(1 / 4);
    }
    else if (variation !== '100') {
        return getNonhomogeneousWidths(variation, numChildren);
    }
    // For when variation is 100
    return Array(numChildren).fill(1);
};
/**
 * Returns an array of responsive arrays of numbers with same length as numChildren. Each value represents the
 * width of the corresponding child.
 * @param variation - variation string to determine how items are sized
 * @param numChildren - number of children
 * @returns
 */
var getChildrenWidths = function (variation, numChildren) {
    if (Array.isArray(variation)) {
        var variationWidths = variation.map(function (v) {
            return getWidthsForVariation(v, numChildren);
        });
        var widthsPerChild = [];
        var _loop_1 = function (i) {
            var widths = variationWidths.map(function (v) { return v && v[i]; });
            widthsPerChild.push(widths);
        };
        for (var i = 0; i < numChildren; i++) {
            _loop_1(i);
        }
        return widthsPerChild;
    }
    else {
        return getWidthsForVariation(variation, numChildren);
    }
};
var memoGetChildrenWidths = moize__WEBPACK_IMPORTED_MODULE_1___default()(getChildrenWidths, { profileName: 'getChildrenWidths' });
// Map named sizes to responsive size values from theme
var gapValues = {
    sm: 1,
    md: 2,
    lg: 3,
    xl: 4,
};
/**
 * Returns an object containing responsive arrays of values for mx to apply to
 * the wrapper flex and px values to apply to the children.
 * @param gapProp - value passed in as gap prop
 * @returns
 */
var getGapValues = function (gapProp, rowGapProp) {
    var boxPaddingX;
    var boxPaddingY;
    var flexMarginX;
    var flexMarginY;
    if (Array.isArray(gapProp)) {
        boxPaddingX = gapProp.map(function (gap) { return gapValues[gap]; });
        // These values are negative because we're trying to offset the padding
        // applied to the left of the first item and right of the last item.
        flexMarginX = gapProp.map(function (gap) { return (gapValues[gap] ? -1 * gapValues[gap] : null); });
    }
    else {
        boxPaddingX = gapValues[gapProp];
        flexMarginX = -1 * gapValues[gapProp];
    }
    if (Array.isArray(rowGapProp)) {
        boxPaddingY = rowGapProp.map(function (gap) { return gapValues[gap] || null; });
        flexMarginY = rowGapProp.map(function (gap) { return (gapValues[gap] ? -1 * gapValues[gap] : null); });
    }
    else {
        boxPaddingY = gapValues[rowGapProp];
        flexMarginY = -1 * gapValues[rowGapProp];
    }
    return { boxPaddingX: boxPaddingX, boxPaddingY: boxPaddingY, flexMarginX: flexMarginX, flexMarginY: flexMarginY };
};
var memoGetGapValues = moize__WEBPACK_IMPORTED_MODULE_1___default()(getGapValues, { profileName: 'getGapValues' });
var ALLOWED_LAYOUT_VALUES = ['50-50', '33-33-33', '33-66', '66-33', '25-25-25-25', '60-40', '40-60', '100'];
var ALLOWED_GAP_VALUES = ['sm', 'md', 'lg', 'xl'];
var propTypes = {
    /** Children will have their widths set based on `variation` */
    children: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().node.isRequired),
    /** Configure widths of children at different breakpoints. Numbers in each variation
     * represent the width of the element in that position as a percentage of `Layout`'s width.
     */
    variation: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(ALLOWED_LAYOUT_VALUES),
        prop_types__WEBPACK_IMPORTED_MODULE_2___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(ALLOWED_LAYOUT_VALUES)),
    ]).isRequired,
    /** Add space between columns */
    gap: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(ALLOWED_GAP_VALUES),
        prop_types__WEBPACK_IMPORTED_MODULE_2___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(ALLOWED_GAP_VALUES)),
    ]),
    /** Add space between rows */
    rowGap: prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOfType([
        prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(ALLOWED_GAP_VALUES),
        prop_types__WEBPACK_IMPORTED_MODULE_2___default().arrayOf(prop_types__WEBPACK_IMPORTED_MODULE_2___default().oneOf(ALLOWED_GAP_VALUES)),
    ]),
    /** Add space between rows */
    stretchHeight: (prop_types__WEBPACK_IMPORTED_MODULE_2___default().bool),
};
var ZIndexBox = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(___WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"])), styled_system__WEBPACK_IMPORTED_MODULE_5__/* .zIndex */ .W5);
var Layout = function (_a) {
    var children = _a.children, gap = _a.gap, rowGap = _a.rowGap, variation = _a.variation, stretchHeight = _a.stretchHeight;
    var widths = memoGetChildrenWidths(variation, children.length);
    var _b = memoGetGapValues(gap, rowGap), boxPaddingX = _b.boxPaddingX, boxPaddingY = _b.boxPaddingY, flexMarginX = _b.flexMarginX, flexMarginY = _b.flexMarginY;
    return (react__WEBPACK_IMPORTED_MODULE_0__.createElement(___WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, { flexWrap: 'wrap', mx: flexMarginX, my: flexMarginY, "data-testid": 'layout-flex' }, react__WEBPACK_IMPORTED_MODULE_0__.Children.map(children, function (child, idx) {
        return child && (react__WEBPACK_IMPORTED_MODULE_0__.createElement(ZIndexBox, { width: widths[idx], px: boxPaddingX, py: boxPaddingY, "data-testid": "box-".concat(idx), zIndex: child.props.zIndex }, react__WEBPACK_IMPORTED_MODULE_0__.cloneElement(child, {
            minHeight: stretchHeight ? '100%' : undefined,
        })));
    })));
};
Layout.propTypes = propTypes;
Layout.defaultProps = {};
Layout.displayName = 'Layout';
/* harmony default export */ __webpack_exports__["Z"] = (Layout);
var templateObject_1;
//# sourceMappingURL=Layout.js.map

/***/ })

}]);